<div class="md:h-[90vh]" *transloco="let t">
  <div class="border-b border-b-grey-300 pt-2xl pb-md text-center md:border-0">
    <h1 class="heading-md">{{ t('createJobRequest.expectation.headerTitle') }}</h1>
    <h2 class="heading-xl">{{ offering!.label }}</h2>
  </div>
  <div class="h-layout bg-white md:flex md:justify-center md:bg-transparent">
    <div class="bg-white p-md md:w-[36rem] md:rounded-3 md:p-xl md:shadow-1">
      <h3 class="mb-xs text-center heading-lg">{{ t('createJobRequest.expectation.title') }}</h3>
      <p class="mb-md text-center text-president-200">{{ t('createJobRequest.expectation.byline') }}</p>
      <div class="mt-xl space-y-lg">
        <cft-checkbox [formControl]="clientExpectationControls.consulting">
          <span class="inline-flex items-center">
            <cft-dynamic-icon class="mr-4 text-2xl" [icon]="calculateCostIcon"></cft-dynamic-icon>
            {{ t('createJobRequest.expectation.consulting') }}
          </span>
        </cft-checkbox>
        <cft-checkbox [formControl]="clientExpectationControls.estimation">
          <span class="inline-flex items-center">
            <cft-dynamic-icon class="mr-4 text-2xl" [icon]="consultingIcon"></cft-dynamic-icon>
            {{ t('createJobRequest.expectation.estimation') }}
          </span>
        </cft-checkbox>
        <cft-checkbox [formControl]="clientExpectationControls.offer">
          <span class="inline-flex items-center">
            <cft-dynamic-icon class="mr-4 text-2xl" [icon]="getOfferIcon"></cft-dynamic-icon>
            {{ t('createJobRequest.expectation.offer') }}
          </span>
        </cft-checkbox>
        <cft-checkbox [formControl]="clientExpectationControls.execution">
          <span class="inline-flex items-center">
            <cft-dynamic-icon class="mr-4 text-2xl" [icon]="executionIcon"></cft-dynamic-icon>
            {{ t('createJobRequest.expectation.execution') }}
          </span>
        </cft-checkbox>
        @if (formGroup.errors?.atLeastOneOptionSelected && formGroup.touched) {
          <div class="error">
            {{ t('createJobRequest.expectation.validationError') }}
          </div>
        }
        <div class="flex justify-between">
          @if (intentionsEnabled()) {
            <button class="btn btn-ghost" (click)="back()">
              {{ t('createJobRequest.expectation.back') }}
            </button>
          }
          <button class="mr-0 ml-auto btn btn-vermilion" (click)="next()">
            {{ t('createJobRequest.expectation.next') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
